<template>
  <div>
    <div class="mt-2 mb-0">
      <v-slide-x-transition group>
        <v-card rounded="xl" outlined width="100%" v-for="(item, index) in array_place_hostel"
                :key="array_place_hostel.indexOf(item)"
                :class="index > 0 ? 'mt-5' : 'mt-0'"
        >
          <div class="ml-10 mt-2 h5 text--secondary" style="position: absolute">{{ 'МЕСТО № ' + (index + 1) }}</div>
          <div class="d-flex justify-end">
            <v-btn
                class="ma-2 mb-4"
                absolute
                @click="removeItemHostel(item)"
                x-small
                fab
                outlined
                color="error"
            >
              <v-icon size="15px" dark>
                fa-trash
              </v-icon>
            </v-btn>
          </div>
          <v-row class="ma-5" ref="selects">
            <v-col cols="12" md="6" class="pb-0">
              <v-select
                  label="Общежитие"
                  :value="item.name_hostel"
                  @input="setNameHostel({index_item: array_place_hostel.indexOf(item), value:$event})"
                  :items="placesHostels"
                  item-text="name_hostel"
                  :rules="[v => !!v || 'Обязательное поле не заполнено']"
                  no-data-text="Данные отсутствуют"
                  hide-details
                  rounded
                  outlined
                  required
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <v-select
                  label="Секция"
                  :value="item.name_section"
                  @input="setNameSection({index_item: array_place_hostel.indexOf(item), value:$event})"
                  :items="placeSections(item.name_hostel)"
                  item-text="name_section"
                  item-value="name_section"
                  :rules="[v => !!v || 'Обязательное поле не заполнено']"
                  no-data-text="Данные отсутствуют"
                  hide-details
                  rounded
                  outlined
                  required
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" class="pb-0">
              <v-select
                  label="Комната"
                  :value="item.name_room"
                  @input="setNameRoom({index_item: array_place_hostel.indexOf(item), value:$event})"
                  :items="placeRooms(item.name_hostel, item.name_section)"
                  item-text="name_room"
                  item-value="name_room"
                  :rules="[v => !!v || 'Обязательное поле не заполнено']"
                  no-data-text="Данные отсутствуют"
                  hide-details
                  rounded
                  outlined
                  required
              ></v-select>
            </v-col>
          </v-row>
        </v-card>
      </v-slide-x-transition>
    </div>
    <div class="text-center mt-2" v-if="array_place_hostel.length < 3">
      <v-btn
          @click="addArrayHostel()"
          fab
          x-small
          dark
          depressed
          color="teal"
      >
        <v-icon dark>
          fa-plus
        </v-icon>
      </v-btn>
    </div>

    <v-alert
        v-else class="lighten-4 lighten-3 pa-3 text-h6 mt-2"
        border="left"
        text
        color="teal"
        type="success"
    >Вы выбрали максимальное количество мест
    </v-alert>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions, mapGetters} from "vuex";
import _ from 'lodash'

export default {
  name: "FormSectionHostel",
  data: () => ({
    sections: [],
    rooms: [],
  }),
  mounted() {
  },
  watch: {},
  computed: {
    ...mapState({
      array_place_hostel: state => state.interactionStatement.statement_hostel.array_place_hostel,
      distribution_places: state => state.placesInDormitories.distribution_places,
    }),
    ...mapGetters({}),
    placesHostels() {
      let ms_hostel = []

      this.distribution_places?.places.forEach((places) => {
        ms_hostel.push(places.name_hostel)
      })

      return ms_hostel
    },
  },
  methods: {
    ...mapMutations({
      setNameHostel: 'interactionStatement/setNameHostel',
      setNameSection: 'interactionStatement/setNameSection',
      setNameRoom: 'interactionStatement/setNameRoom',
      addArrayHostel: 'interactionStatement/addArrayHostel',
      removeItemHostel: 'interactionStatement/removeItemHostel',
    }),
    ...mapActions({}),
    placeSections(name_hostel) {
      let curr_sections = []

      if (name_hostel) {
        let hostel = _.find(this.distribution_places?.places, (place) => {
          return place.name_hostel === name_hostel
        })

        hostel.sections.forEach((section) => {
          curr_sections.push(section)
        })
      }

      return curr_sections
    },
    placeRooms(name_hostel, name_section) {
      let curr_sections = this.placeSections(name_hostel)
      let curr_rooms = []

      if (name_hostel && name_section) {
        let section = _.find(curr_sections, (place) => {
          return place.name_section === name_section
        })

        section.rooms.forEach((room) => {
          curr_rooms.push(room.name_room)
        })
      }

      return curr_rooms
    },
  },
}
</script>

<style scoped>

</style>